import { BasicLayout } from './Layouts/basicLayout'
import './clientDashboard.css'
import { Link, useNavigate} from 'react-router-dom'
import 'react-datepicker/dist/react-datepicker.css'
import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { authorInterface, categoryInterface, reportInterface } from '../interfaces/report'
import moment from 'moment'
import { filtersInterface } from '../interfaces/filters'
import { useGlobalContent } from '../context/helpersProvider'
import { Pagination } from '../components/Pagination'
import expiredToken from '../utils/headerAuth'
import { parentCategories } from '../interfaces/categories'
import DatePicker from 'react-datepicker'
import { MultiSelect } from 'primereact/multiselect'
import removeIcon from '../media/white_recyclebin_icon.svg'

export const ClientDashBoard = (props: any) => {

  const history = useNavigate()

  const [Filters, setFilters] = useState<filtersInterface>({
    category: [],
    author: 0,
    content: '',
  })

  interface reportsInterface extends Array<reportInterface> { }

  interface Author {
    id: number;
    name: string;
  }

  const [authors, setAuthors] = useState<Author[]>([]);
  const [reports, setReports] = useState([])


  const [initDate, setInitDate] = useState(new Date())
  const [dateEnd, setDateEnd] = useState(new Date())
  const [currentItem, setCurrentItems] = useState<reportsInterface>()


  const { setShowLoading, setShowToast } = useGlobalContent()
  const [content, setContent] = useState("");
  const contentRef = useRef('');


  const [dynamicCategories, setDynamicCategories] = useState<any[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<{ [key: string]: any[] }>({});
  const [availableCategories, setAvailableCategories] = useState<parentCategories[]>([]);
  const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout | null>(null);

  const handleAuthors = () => {
    let arrAuthors = [] as any
    arrAuthors.push({ id: '', name: 'Select analyst' })
    axios.get(`/report/authors`)
      .then((response) => {

        if (response.data.status === 201) {
          for (const author of response.data.data) {
            arrAuthors.push({ id: author.id, name: author.name })
          }
          setAuthors(arrAuthors)
        }
      })
      .catch((err) => {
        expiredToken(history, err, setShowToast);
      });
  }

  const getCategorys = async () => {
    axios.get(`/category/gets`)
      .then((response) => {
        const filteredCategories = response.data.data.filter((category: any) =>
          category.sub_categories && category.sub_categories.length > 0
        );

        const categories = filteredCategories.map((category: any) => ({
          label: category.name,
          code: category.id,
          items: category.sub_categories.map((sub: any) => ({
            label: sub.name,
            value: sub.id
          }))
        }));

        setDynamicCategories(categories);
        setAvailableCategories(response.data.data);

        // Inicializar estados de categorías seleccionadas
        const initialSelectedCategories: { [key: string]: any[] } = {};
        categories.forEach((category: any) => {
          initialSelectedCategories[category.label] = [];
        });
        setSelectedCategories(initialSelectedCategories);
      })
      .catch((err) => {
        expiredToken(history, err, setShowToast);
      });
  }

  useEffect(() => {
    handleAuthors();
    getCategorys();

  }, [])

  useEffect(() => {
    if (authors.length > 0)
      getAllReports();
  }, [authors])


  const getAllReports = () => {
    // let sessionId = localStorage.getItem('idClient')
    setShowLoading('true')
    axios
      .get(`/report/reports/getAll/all`)
      .then((json) => json.data)
      .then((datos) => {
        setShowLoading('false')
        let arrReporte: any = []
        for (const report of datos.data) {
          if (report.publish_date != null) {
            arrReporte.push(report)
          }
        }
        const sortedData = arrReporte.sort((a: any, b: any) => {
          const dateA = new Date(a.publish_date)
          const dateB = new Date(b.publish_date)

          if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
            // Si alguna fecha es inválida, regresa 0 para mantener el orden actual
            return 0
          }

          const diffInMs = dateB.getTime() - dateA.getTime()

          return diffInMs
        })

        sortedData.forEach((report: any) => {
          if (report.categories && authors?.length > 0) {
            const matchingAnalysts = report.categories
              .filter((category: any) => authors?.some((a: any) => a.id === category.id))
              .map((category: any) => {
                const analyst = authors?.find((a: any) => a.id === category.id);
                return analyst ? analyst.name : null;
              })
              .filter((name: string | null) => name !== null);
            report.analistas = matchingAnalysts.join(', ');
          } else {
            report.analistas = '';
          }
        });

        setReports(sortedData)
      })
      .catch((err) => {
        setShowLoading('false')
        console.log(err)
        expiredToken(history, err, setShowToast)
        setShowToast({
          open: 'true',
          type: 'error',
          message: 'Something went wrond during report charge',
        })
      })
  }

  const filterReports = (e: any) => {
    e.preventDefault()
    const currentContent = contentRef.current;
    const selectedCategoryIds = Object.values(selectedCategories).flat();

    const formattedFirstDate = initDate ? new Date(initDate).toISOString().split('T')[0] : null;
    const formattedLastDate = dateEnd ? new Date(dateEnd).toISOString().split('T')[0] : null;
    if (
      currentContent.trim() === '' &&
      selectedCategoryIds.length === 0 &&
      formattedFirstDate === null &&
      formattedLastDate === null &&
      Filters.author === 0
    ) {
      getAllReports()
      return
    }

    setShowLoading('true')
    axios
      .post('/user/search', {
        content: currentContent.trim(),
        category: selectedCategoryIds,
        auth_id: [],
        first_date: "",
        last_date: "",
      })
      .then((json) => json.data)
      .then((datos) => {
        if (datos.status != 200) {
          setShowToast({
            open: 'true',
            type: 'error',
            message: datos.message,
          })
        } else {
          let arrReporte: any = []
          for (const report of datos.data) {
            if (report.publish_date != null) {
              arrReporte.push(report)
            }
          }
          const sortedData = arrReporte.sort((a: any, b: any) => {
            const dateA = new Date(a.publish_date)
            const dateB = new Date(b.publish_date)

            if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
              // Si alguna fecha es inválida, regresa 0 para mantener el orden actual
              return 0
            }

            const diffInMs = dateB.getTime() - dateA.getTime()

            return diffInMs
          })

          sortedData.forEach((report: any) => {
            if (report.categories && authors?.length > 0) {
              const matchingAnalysts = report.categories
                .filter((category: any) => authors?.some((a: any) => a.id === category.id))
                .map((category: any) => {
                  const analyst = authors?.find((a: any) => a.id === category.id);
                  return analyst ? analyst.name : null;
                })
                .filter((name: string | null) => name !== null);
              report.analistas = matchingAnalysts.join(', ');
            } else {
              report.analistas = '';
            }
          });

          setReports(sortedData)
        }
        setShowLoading('false')
      })
      .catch((err) => {
        console.log(err)
        expiredToken(history, err, setShowToast)
      })
  }


  const trimOnBlur = () => {
    setFilters({ ...Filters, content: Filters.content.trim() })
  }

  const handleKeypress = (e: any) => {
    if (e.keyCode === 'Enter') {
      trimOnBlur()
      filterReports(e)
    }
  }

  useEffect(() => {
    const currentDate = new Date()

    // Calcula el día de 3 meses de anterioridad al día actual
    const initialDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - 3,
      currentDate.getDate()
    )

    setInitDate(initialDate)

    setDateEnd(currentDate)
  }, []);

  const download = (id: any) => {
    let sessionId = localStorage.getItem('idClient');
    let data = {
      report_id: id,
      user_id: parseInt(sessionId !== null && JSON.parse(sessionId)),
    };

    setShowLoading('true');
    axios
      .post(`/user/file`, data, { responseType: 'blob' })
      .then((res) => {
        if (res.status === 200) {
          setShowLoading('false');
          const contentDisposition = res.headers['content-type'];
          const filename = contentDisposition;

          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: 'application/pdf' }) // tipo de archivo correcto
          );

          // Abre el archivo en una nueva pestaña en lugar de descargarlo
          const newWindow = window.open(url, '_blank');
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            setShowToast({
              open: 'true',
              message: 'Unable to open the file. Please check your browser settings or try again.',
              type: 'error',
            });
          } else {
            setShowToast({
              open: 'true',
              message: 'File opened successfully',
              type: 'success',
            });
          }
        } else {
          setShowToast({
            open: 'true',
            message: "Sorry, the file was not found.",
            type: 'error',
          });
        }
      })
      .catch((err) => {
        setShowLoading('false');
        expiredToken(history, err, setShowToast);
        setShowToast({
          open: 'true',
          message: 'Sorry, the file was not found.',
          type: 'error',
        });
        return err;
      });
  };

  const handleSearch = (selectedCategories: any) => { // Aceptamos selectedCategories como parámetro
    const selectedCategoryIds = Object.values(selectedCategories).flat(); // Aseguramos que trabajamos con las categorías seleccionadas

    const formattedFirstDate = initDate ? new Date(initDate).toISOString().split('T')[0] : '';
    const formattedLastDate = dateEnd ? new Date(dateEnd).toISOString().split('T')[0] : '';

    setShowLoading('true');

    // Realizamos la búsqueda enviando los filtros correctos
    axios.post('/user/search', {
      content: content, // Si estás usando el filtro de contenido también, ajústalo aquí
      category: selectedCategoryIds, // Aquí pasamos las categorías seleccionadas
      first_date: formattedFirstDate,
      last_date: formattedLastDate,
      auth_id: [],
    })
      .then((json) => json.data)
      .then((datos) => {
        if (datos.status !== 200) {
          setShowToast({
            open: 'true',
            type: 'error',
            message: datos.message,
          });
        } else {
          const arrReporte = datos.data.filter((report: any) => {
            // Extraemos los IDs de categorías del informe
            const reportCategoryIds = report.categories.map((category: any) => category.id);
            // Comprobamos si cada categoría seleccionada está en las categorías del informe
            return !selectedCategoryIds || selectedCategoryIds.length === 0 || selectedCategoryIds.some((selectedId: any) => reportCategoryIds.includes(selectedId));
          });

          const sortedData = arrReporte.sort((a: any, b: any) => {
            const dateA = new Date(a.publish_date);
            const dateB = new Date(b.publish_date);

            return isNaN(dateA.getTime()) || isNaN(dateB.getTime()) ? 0 : dateB.getTime() - dateA.getTime();
          });

          sortedData.forEach((report: any) => {
            if (report.categories && authors?.length > 0) {
              const matchingAnalysts = report.categories
                .filter((category: any) => authors?.some((a: any) => a.id === category.id))
                .map((category: any) => {
                  const analyst = authors?.find((a: any) => a.id === category.id);
                  return analyst ? analyst.name : null;
                })
                .filter((name: string | null) => name !== null);
              report.analistas = matchingAnalysts.join(', ');
            } else {
              report.analistas = '';
            }
          });

          setReports(sortedData);
        }
        setShowLoading('false');
      })
      .catch((err) => {
        expiredToken(history, err, setShowToast);
      });
  };


  const handleCategoryChange = (selected: number[], parentId: number) => {
    setSelectedCategories((prev: any) => ({
      ...prev,
      [parentId]: selected, // Actualizar las categorías seleccionadas por parentId
    }));
  };

  const renderCategorySection = () =>
    availableCategories.map((parent: any, index: number) => (
      <div key={index}>
        <label className="field-label">{parent.name}</label>
        <MultiSelect
          value={selectedCategories[parent.id] || []} // Obtener categorías seleccionadas para este parentId
          options={parent.sub_categories} // Subcategorías disponibles
          onChange={(e: any) => handleCategoryChange(e.value, parent.id)} // Manejar cambios
          optionLabel="name"
          optionValue="id"
          placeholder={`Select ${parent.name}`}
          className="select-field-report w-select-prime p-multiselect-item-group"
          style={{
            background: '#e7e9fa',
            border: 'none',
            color: '#333',
            fontWeight: 400,
            fontSize: '15px'
          }}
          appendTo={document.body}
          panelHeaderTemplate={() => <></>}
        />

      </div>
    ));

  // const renderCategorySection = () =>
  //   availableCategories.map((parent: any, index: number) => (
  //     <div key={index} style={{ marginBottom: '20px' }}>
  //       {/* Selector para la categoría principal */}
  //       <label className="field-label">{parent.name}</label>
  //       <MultiSelect
  //         value={selectedCategories[parent.id] || []} // Obtener categorías seleccionadas para este parentId
  //         options={parent.sub_categories} // Subcategorías disponibles
  //         onChange={(e: any) => handleCategoryChange(e.value, parent.id)} // Manejar cambios
  //         optionLabel="name"
  //         optionValue="id"
  //         placeholder={`Select...`}
  //         className="select-field w-select-prime p-multiselect-item-group"
  //         style={{
  //           background: '#e7e9fa',
  //           border: 'none',
  //           color: '#333',
  //           fontWeight: 600,
  //           fontSize: '15px',
  //           whiteSpace: 'normal',
  //           overflow: 'visible',
  //           paddingRight: '0', // Elimina el espacio reservado
  //           width: '100%'
  //         }}
  //         appendTo={document.body}
  //         panelHeaderTemplate={() => <></>}
  //       />

  //       {/* Categorías seleccionadas para este selector */}
  //       {selectedCategories[parent.id] && selectedCategories[parent.id].length > 0 && (
  //         <div className="selected-category-list" style={{ marginTop: '10px' }}>
  //           {selectedCategories[parent.id].map((itemId) => (
  //             <div
  //               key={itemId}
  //               className="selected-category-item"
  //               style={{
  //                 display: 'flex',
  //                 alignItems: 'center',
  //                 //gap: '10px',
  //                 background: '#151f6d',
  //                 color: '#fff',
  //                 borderRadius: '10px',
  //                 padding: '5px 5px',
  //                 marginBottom: '6px',
  //                 fontSize: '10px',
  //               }}
  //             >
  //               <span>{getCategoryLabelById(parent.id, itemId)}</span>
  //               <button
  //                 onClick={(e) => {
  //                   e.preventDefault();
  //                   deleteCategorySelect(itemId, parent.id);
  //                 }}
  //                 className="remove-category-btn"
  //                 style={{
  //                   background: 'transparent',
  //                   border: 'none',
  //                   cursor: 'pointer',
  //                 }}
  //               >
  //                 <img
  //                   src={removeIcon}
  //                   alt="Remove"
  //                   style={{ width: '16px', height: '16px' }}
  //                 />
  //               </button>
  //             </div>
  //           ))}
  //         </div>
  //       )}
  //     </div>
  //   ));

  const renderSelectedCategories = () => {
    // Combina todas las categorías seleccionadas en un solo arreglo
    const selectedItems = Object.entries(selectedCategories).flatMap(([parentId, items]) =>
      items.map((itemId) => ({
        id: itemId,
        parentId: Number(parentId), // Relaciona con el parentId
        label: getCategoryLabelById(Number(parentId), itemId), // Obtiene el nombre de la subcategoría
        parentLabel: availableCategories.find((cat) => cat.id === Number(parentId))?.name, // Nombre de la categoría principal
      }))
    );

    return (
      <div>
        {selectedItems.length > 0 && (
          <div>
            <div className="selected-category-list">
              {selectedItems.map((item) => (
                <div
                  key={item.id}
                  className="selected-category-item"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0px',
                    background: '#151f6d',
                    color: '#fff',
                    borderRadius: '10px',
                    padding: '5px 5px',
                    margin: '10px 0px',
                    fontSize: '10px',
                  }}
                >
                  <span
                  style={{
                    marginLeft: '10px',
                  }}
                  >
                    {item.label}
                  </span>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      deleteCategorySelect(item.id, item.parentId);
                    }}
                    className="remove-category-btn"
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    <img
                      src={removeIcon}
                      alt="Remove"
                      style={{ width: '16px', height: '16px' }}
                    />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const deleteCategorySelect = (categoryId: number, parentId: number) => {
    setSelectedCategories((prev: any) => {
      const updated = { ...prev };
      updated[parentId] = updated[parentId].filter((id: any) => id !== categoryId);
      return updated;
    });
  };

  // const renderSelectedCategories = () => {
  //   return Object.entries(selectedCategories).map(([parentId, selectedItems]) => (
  //     <div key={parentId}>
  //       {selectedItems.length > 0 && (
  //         <div>
  //           <div className="selected-category-list">
  //             {selectedItems.map((item) => (
  //               <div
  //                 key={item}
  //                 className="selected-category-item"
  //                 style={{
  //                   display: 'flex',
  //                   alignItems: 'center',
  //                   gap: '10px',
  //                   background: '#151f6d',
  //                   color: '#fff',
  //                   borderRadius: '10px',
  //                   padding: '5px 10px',
  //                 }}
  //               >
  //                 <span>{`${getCategoryLabelById(Number(parentId), item)}`}</span> {/* Número y Nombre */}
  //                 <button
  //                   onClick={(e) => {
  //                     e.preventDefault();
  //                     deleteCategorySelect(item, Number(parentId));
  //                   }}
  //                   className="remove-category-btn"
  //                   style={{
  //                     background: 'transparent',
  //                     border: 'none',
  //                     cursor: 'pointer',
  //                   }}
  //                 >
  //                   <img
  //                     src={removeIcon}
  //                     alt="Remove"
  //                     style={{ width: '16px', height: '16px' }}
  //                   />
  //                 </button>
  //               </div>
  //             ))}
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   ));
  // };


  const getCategoryLabelById = (parentId: number, id: number) => {
    // Encuentra la categoría principal por el parentId
    const parentCategory = dynamicCategories.find((cat: any) => cat.code === parentId);

    if (parentCategory) {
      // Busca el subelemento dentro de los items de la categoría principal
      const subCategory = parentCategory.items.find((subItem: any) => subItem.value === id);
      return subCategory ? subCategory.label : '';
    }

    return ''; // Devuelve vacío si no se encuentra
  };


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContent(e.target.value);
    const value = e.target.value;
    contentRef.current = value;
    // Si ya existe un timeout pendiente, lo cancelamos
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    const newTimeout = setTimeout(() => {
      filterReports(e);
    }, 500);

    setTypingTimeout(newTimeout);
  };

  useEffect(() => {
    // Solo ejecutamos la búsqueda cuando selectedCategories cambie
    handleSearch(selectedCategories);
  }, [selectedCategories]);

  return (
    <BasicLayout>
      <div className='content-div'>
        <h4 className='h3-title'>Reports Library</h4>
        <div className='search-filters-form'>
          <form method='get' name='wf-form--2'>
            <div className='field-search'>
              {/* <label id='Search' htmlFor='field' className='field-label'>
                Search by Keyword
              </label> */}
              <div className='search-wrapper'>
                <input
                  type='text'
                  className='search-field search'
                  autoFocus={true}
                  name='content'
                  onKeyDown={handleKeypress}
                  placeholder='Search Report by Keyword'
                  autoComplete='off'
                  value={content}
                  onChange={(e: any) => handleChange(e)}
                />
                <button className='search-btn w-button' onClick={filterReports}></button>
              </div>
              <div className='separador-form'></div>
              <label style={{ color: '#151f6d', fontSize: '16px' }}>OR SEARCH BY DATE, TOPIC, COUNTRY, SECTOR AND ANALYST</label>
            </div>
            <div className="search-filters-div">
              <div>
                <label htmlFor='field' className='field-label'>Initial Date</label>
                <DatePicker
                  id='start'
                  dateFormat='yyyy/MM/dd'
                  selected={initDate}
                  onChange={(date : Date | null) => date && setInitDate(date)}
                  className='select-field-report-date w-select'
                />
              </div>
              <div>
                <label htmlFor='field' className='field-label'>End Date</label>
                <DatePicker
                  id='end'
                  dateFormat='yyyy/MM/dd'
                  selected={dateEnd}
                  onChange={(date : Date | null) => date && setDateEnd(date)}
                  className='select-field-report-date w-select'
                />
              </div>
              {renderCategorySection()}
              <div>
                <label htmlFor='field' className='field-label'>Search</label>
                <button type='button' onClick={() => handleSearch(selectedCategories)} className='search-btn-report margin w-button'></button>
              </div>
            </div>
            <div className="container-category-select">
              {renderSelectedCategories()}
            </div>

          </form>
        </div>
        <div className='separador'></div>
        {reports.length > 0 ? (
          <>
            <h4 className="h3-short-title">Recently Published</h4>
            <div className='results-section'>
              {currentItem?.map((e) => {
                return (
                  <div
                    className='report w-inline-block report-content'
                    style={{ cursor: 'pointer' }}
                    onClick={() => download(e?.report_id)}
                    key={e?.report_id}
                  >
                     {e.thumbnail_location ? <img
                        src={`${process.env.REACT_APP_API}${e.thumbnail_location}`}
                        width="120" height="180"
                        alt={"thumbnail"+e.thumbnail_location}/> :
                        <div className={e.report_type === 'Full Report' ? 'report-miniature' : 'report-miniature2'}></div>}
                    <div className='report-info'>
                      <div style={{ marginBottom: 10 }}>{e.report_type}</div>
                      <div>
                        <div className='report-tag'>{e.categories[0]?.name}</div>
                        {/* {e.categories.length > 1 && (
                    <div className='report-tag'>+{e.categories.length - 1}</div>
                  )} */}
                      </div>
                      <div>
                        <h5 className='report-title'>{e.name}</h5>
                        <div>{e?.analistas}</div>
                      </div>
                      <div>
                        <div className='report-date'>
                          {' '}
                          {moment(e.publish_date).format('YYYY/MM/DD')}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            <Pagination data={reports} state={setCurrentItems} items={12}></Pagination>
          </>
        ) : (
          <h5 className='center-h5'>No reports found. We might not have what you are looking for, but please double-check the search bar or the filtering options</h5>
        )}

      </div>
    </BasicLayout>
  )
}
